var map = {
	"./mx_insurama.png": "4cc6",
	"./mx_seguromovil.png": "48c0",
	"./mx_seguromultidispositivo.png": "5ded",
	"./mx_seguroportatil.png": "bd0e",
	"./pt_insurama.png": "b01c",
	"./pt_seguromovil.png": "5c87",
	"./pt_seguromultidispositivo.png": "93d8",
	"./pt_seguroportatil.png": "efa0"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "26a7";